import { slice } from 'ramda'

import { NodeTypes, OperatorTypes, Operators, ParserTypes, TokenTypes } from '../../constants'
import createDollarSignOperator from '../pipes/createDollarSignOperator'
import { getTokenListPosition } from '../util'

const DollarSignOperator = {
  identify: (context, node) => node,
  is: (value) =>
    value && value.type === NodeTypes.OPERATOR && value.operatorType === OperatorTypes.DOLLAR_SIGN,
  parse: (context, tokenList) => {
    const nextToken = tokenList.get(0)
    if (!nextToken) {
      throw new Error(
        `Expected operator '${Operators.DOLLAR_SIGN}'. Instead reached the end of the file.`
      )
    }
    if (nextToken.type !== TokenTypes.OPERATOR_DOLLAR_SIGN) {
      const { lastLineCharacterCount, lineCount } = getTokenListPosition(context, tokenList)
      throw new Error(
        `Expected operator '${Operators.DOLLAR_SIGN}'. Instead was given '${
          tokenList.get(0).value
        }' at ${lineCount}:${lastLineCharacterCount}`
      )
    }
    return createDollarSignOperator({
      tokenList: slice(0, 1, tokenList)
    })
  },
  test: (context, tokenList) => tokenList.get(0).type === TokenTypes.OPERATOR_DOLLAR_SIGN,
  type: ParserTypes.OPERATOR
}

export default DollarSignOperator
